// extracted by mini-css-extract-plugin
export default {"button":"SBPBankItem_button__N3wtX","icon":"SBPBankItem_icon__a-NhV"};